import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { EntrepriseOffreBreadCrumb } from "../../components/breadCrumb/EntrepriseOffreBreadCrumb"
import { FormAnnonceInterne } from "../../components/form/annonce/formAnnonceInterne"
import { ProgressSpinner } from "primereact/progressspinner"
import OffreEmploiService from "../../services/offreEmploiService"
import "./annonceInterne.css"

export const AnnonceInterne = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [canCreateOffer, setCanCreateOffer] = useState(false);
  
  const offreEmploiService = new OffreEmploiService();
  const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;

  useEffect(() => {
    checkMaxOffersLimit();
  }, []);

  const checkMaxOffersLimit = async () => {
    try {
      const canCreate = await offreEmploiService.canCreateNewOffer(adminImpersonatingRecruteurId);
      
      if (!canCreate) {
        history.push("/unauthorized");
        return;
      }
      
      setCanCreateOffer(true);
    } catch (error) {
      history.push("/offers");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="fai-loading-container">
        <ProgressSpinner />
      </div>
    );
  }

  if (!canCreateOffer) {
    return null;
  }

  return (
    <div>
      <EntrepriseOffreBreadCrumb step={1} label={t('advert.create_offer')} />
      <FormAnnonceInterne />
    </div>
  )
}